/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import UserActivityTracker from '../components/ActivityTracker/UserActivityTracker';
import ChangePassword from '../components/ChangePassword/ChangePassword';
import ContactUs from '../components/ContactUs/ContactUs';
import ContentCards from '../components/ContentCards/ContentCards';
import ContentCard from '../components/ContentCards/sub-components/ContentCard';
import Correspondence from '../components/Correspondence/Correspondence';
import EPost from '../components/EPost/EPost';
import ErrorBox from '../components/ErrorBox/ErrorBox';
import FaqItems from '../components/FaqItems/FaqItems';
import FaqSectionNavigation from '../components/FaqItems/FaqSectionNavigation';
import Footer from '../components/Footer/Footer';
import FooterBottomLinks from '../components/Footer/FooterBottomLinks';
import FooterIconLinks from '../components/Footer/FooterIconLinks';
import FooterLinksList from '../components/Footer/FooterLinksList';
import FooterBottomLink from '../components/Footer/sub-components/FooterBottomLink';
import FooterColumnLink from '../components/Footer/sub-components/FooterColumnLink';
import FooterCopyright from '../components/Footer/sub-components/FooterCopyright';
import FooterDisclaimer from '../components/Footer/sub-components/FooterDisclaimer';
import FooterIconLink from '../components/Footer/sub-components/FooterIconLink';
import FooterLogo from '../components/Footer/sub-components/FooterLogo';
import FooterNavigation from '../components/Footer/sub-components/FooterNavigation';
import ForgotUserId from '../components/ForgotUserId/ForgotUserId';
import FormList from '../components/FormList/FormList';
import Header from '../components/Header/Header';
import HeaderLinksList from '../components/Header/HeaderLinksList';
import HeaderLogos from '../components/Header/HeaderLogos';
import AccountMenu from '../components/Header/sub-components/AccountMenu';
import HeaderLink from '../components/Header/sub-components/HeaderLink';
import HeaderLogo from '../components/Header/sub-components/HeaderLogo';
import HeaderLogoDivider from '../components/Header/sub-components/HeaderLogoDivider';
import HelpCard from '../components/HelpCard/HelpCard';
import ImageCards from '../components/ImageCards/ImageCards';
import ImageCard from '../components/ImageCards/sub-components/ImageCard';
import AdviserDetails from '../components/InvestmentDetails/AdviserDetails';
import BankDetails from '../components/InvestmentDetails/BankDetails';
import BeneficiaryDetails from '../components/InvestmentDetails/BeneficiaryDetails';
import DetailsTable from '../components/InvestmentDetails/DetailsTable';
import Distribution from '../components/InvestmentDetails/Distribution';
import InvestmentDetails from '../components/InvestmentDetails/InvestmentDetails';
import TaxDetails from '../components/InvestmentDetails/TaxDetails';
import Transactions from '../components/InvestmentDetails/Transactions';
import JssMainError from '../components/JssMainError/JssMainError';
import LoadingBox from '../components/LoadingBox/LoadingBox';
import Login from '../components/Login/Login';
import Logout from '../components/Logout/Logout';
import MobileNavigation from '../components/MobileNavigation/MobileNavigation';
import MyInvestmentsOverview from '../components/MyInvestmentsOverview/MyInvestmentsOverview';
import AdditionalContent from '../components/PageContent/AdditionalContent';
import PageContent from '../components/PageContent/PageContent';
import PreLoginCard from '../components/PreLoginCard/PreLoginCard';
import ProfileDetails from '../components/ProfileDetails/ProfileDetails';
import PromoCards from '../components/PromoCards/PromoCards';
import _BasePromoCard from '../components/PromoCards/base-component/_BasePromoCard';
import CentrelinkCard from '../components/PromoCards/sub-components/CentrelinkCard';
import PromoCard from '../components/PromoCards/sub-components/PromoCard';
import RefreshToken from '../components/RefreshToken/RefreshToken';
import SitecoreLink from '../components/Sitecore/SitecoreLink';
import SitecoreMultiline from '../components/Sitecore/SitecoreMultiline';
import SubsetView from '../components/TermsAndConditions/SubsetView';
import TermsAndConditions from '../components/TermsAndConditions/TermsAndConditions';
import ThankYou from '../components/ThankYou/ThankYou';
import BackToLink from '../components/TopNavigation/BackToLink';
import TopNavigation from '../components/TopNavigation/TopNavigation';
import TwoColumnsContent from '../components/TwoColumnsContent/TwoColumnsContent';
import PageLayout from '../components/layouts/PageLayout';
import TopMenuLayout from '../components/layouts/TopMenuLayout';
import Accordion from '../components/subComponents/Accordion/Accordion';
import AccountTable from '../components/subComponents/AccountTable/AccountTable';
import DetailsBox from '../components/subComponents/DetailsBox/DetailsBox';
import MaturityBanners from '../components/subComponents/MaturityBanner/MaturityBanners';
import BaseMaturityBanner from '../components/subComponents/MaturityBanner/base-components/BaseMaturityBanner';
import Pagination from '../components/subComponents/Pagination/Pagination';
import ProgressResponse from '../components/subComponents/ProgressResponse/ProgressResponse';

const components = new Map();
components.set('UserActivityTracker', UserActivityTracker);
components.set('ChangePassword', ChangePassword);
components.set('ContactUs', ContactUs);
components.set('ContentCards', ContentCards);
components.set('ContentCard', ContentCard);
components.set('Correspondence', Correspondence);
components.set('EPost', EPost);
components.set('ErrorBox', ErrorBox);
components.set('FaqItems', FaqItems);
components.set('FaqSectionNavigation', FaqSectionNavigation);
components.set('Footer', Footer);
components.set('FooterBottomLinks', FooterBottomLinks);
components.set('FooterIconLinks', FooterIconLinks);
components.set('FooterLinksList', FooterLinksList);
components.set('FooterBottomLink', FooterBottomLink);
components.set('FooterColumnLink', FooterColumnLink);
components.set('FooterCopyright', FooterCopyright);
components.set('FooterDisclaimer', FooterDisclaimer);
components.set('FooterIconLink', FooterIconLink);
components.set('FooterLogo', FooterLogo);
components.set('FooterNavigation', FooterNavigation);
components.set('ForgotUserId', ForgotUserId);
components.set('FormList', FormList);
components.set('Header', Header);
components.set('HeaderLinksList', HeaderLinksList);
components.set('HeaderLogos', HeaderLogos);
components.set('AccountMenu', AccountMenu);
components.set('HeaderLink', HeaderLink);
components.set('HeaderLogo', HeaderLogo);
components.set('HeaderLogoDivider', HeaderLogoDivider);
components.set('HelpCard', HelpCard);
components.set('ImageCards', ImageCards);
components.set('ImageCard', ImageCard);
components.set('AdviserDetails', AdviserDetails);
components.set('BankDetails', BankDetails);
components.set('BeneficiaryDetails', BeneficiaryDetails);
components.set('DetailsTable', DetailsTable);
components.set('Distribution', Distribution);
components.set('InvestmentDetails', InvestmentDetails);
components.set('TaxDetails', TaxDetails);
components.set('Transactions', Transactions);
components.set('JssMainError', JssMainError);
components.set('LoadingBox', LoadingBox);
components.set('Login', Login);
components.set('Logout', Logout);
components.set('MobileNavigation', MobileNavigation);
components.set('MyInvestmentsOverview', MyInvestmentsOverview);
components.set('AdditionalContent', AdditionalContent);
components.set('PageContent', PageContent);
components.set('PreLoginCard', PreLoginCard);
components.set('ProfileDetails', ProfileDetails);
components.set('PromoCards', PromoCards);
components.set('_BasePromoCard', _BasePromoCard);
components.set('CentrelinkCard', CentrelinkCard);
components.set('PromoCard', PromoCard);
components.set('RefreshToken', RefreshToken);
components.set('SitecoreLink', SitecoreLink);
components.set('SitecoreMultiline', SitecoreMultiline);
components.set('SubsetView', SubsetView);
components.set('TermsAndConditions', TermsAndConditions);
components.set('ThankYou', ThankYou);
components.set('BackToLink', BackToLink);
components.set('TopNavigation', TopNavigation);
components.set('TwoColumnsContent', TwoColumnsContent);
components.set('PageLayout', PageLayout);
components.set('TopMenuLayout', TopMenuLayout);
components.set('Accordion', Accordion);
components.set('AccountTable', AccountTable);
components.set('DetailsBox', DetailsBox);
components.set('MaturityBanners', MaturityBanners);
components.set('BaseMaturityBanner', BaseMaturityBanner);
components.set('Pagination', Pagination);
components.set('ProgressResponse', ProgressResponse);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
